// extracted by mini-css-extract-plugin
module.exports = {"SwipeableViews":"_3SjMZiCgacBt_-mdhFlw5i"};